
import { useState, useEffect } from 'react';

export default function WhatsAppButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isVisible) {
      const tooltipTimer = setTimeout(() => {
        setShowTooltip(true);
        const hideTimer = setTimeout(() => {
          setShowTooltip(false);
        }, 4000);
        return () => clearTimeout(hideTimer);
      }, 3000);
      return () => clearTimeout(tooltipTimer);
    }
  }, [isVisible]);

  return (
    <div
      className={`fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 flex items-center gap-3 transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'
      }`}
    >
      {/* Tooltip */}
      <div
        className={`bg-white rounded-xl shadow-xl px-4 py-2.5 max-w-[200px] transition-all duration-300 hidden sm:block ${
          showTooltip ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        <p className="text-gray-800 text-sm font-medium leading-snug">\u00bfNecesitas ayuda? \u00a1Escr\u00edbenos!</p>
        <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-3 h-3 bg-white rotate-45 shadow-sm"></div>
      </div>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/50765358000"
        target="_blank"
        rel="noopener noreferrer"
        className="group relative w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] hover:bg-[#1ebe5b] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer"
        aria-label="Contactar por WhatsApp"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <i className="ri-whatsapp-line text-white text-2xl sm:text-3xl"></i>
        {/* Pulse animation */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></span>
      </a>
    </div>
  );
}
